module.exports = __webpack_public_path__ + "static/media/Medcare Medical Centre, Khawaneej.e2d075af.jpg";